module.exports = __webpack_public_path__ + "img/tech_image_13.68bbf3b2.jpg";